import { gql } from "graphql-tag"

export default gql`
  type Label {
    brandAliases: [String]
    createdAt: String!
    id: ID!
    imprintOfLabelId: ID
    isPublished: Boolean!
    publishedAt: String
    status: LabelStatus!
    url: String
    vendor: Vendor!
    updatedAt: String!
  }

  enum LabelStatus {
    active
    inactive
    defunct
  }

  input LabelAddInput {
    imprintOfLabelId: ID
    isPublished: Boolean!
    publishedAt: String
    status: LabelStatus!
    url: String
    vendorId: ID!
  }

  input LabelUpdateInput {
    imprintOfLabelId: ID
    isPublished: Boolean
    publishedAt: String
    status: LabelStatus
    url: String
    vendorId: ID
  }

  type LabelsWave {
    cursor: String
    labels: [Label]!
    hasPrevData: Boolean
    hasNextData: Boolean!
    prevCursor: String
  }

  input GetQueryLabels {
    createdAt: String
    isAscending: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetWaveQueryLabels {
    createdAt: String
    cursor: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input SearchLabelsInput {
    name: String
  }

  input SearchLabelsByUrlInput {
    url: String
  }
`
